import * as React from "react";
import { Box, BoxProps, styled } from "@mui/material";
import PosterImage, { PosterImageProps } from "../PosterImage";

export interface PosterImagePackProps extends BoxProps {
  imgs: PosterImageProps["img"][];
  posterProps: BoxProps;
}

const PosterImagePack: React.FC<PosterImagePackProps> = (props) => {
  const { imgs, posterProps, ...otherProps } = props;

  return (
    <StyledList {...otherProps}>
      {imgs.map((img, key) => (
        <PosterImage key={img.src} {...posterProps} img={img} />
      ))}
    </StyledList>
  );
};

export default PosterImagePack;

const StyledList = styled(Box)(({ theme }) => ({
  display: "flex",
  figure: {
    flexShrink: 0,
  },
  "figure + figure": {
    marginLeft: theme.spacing(-2),
    borderLeft: `1px solid ${theme.palette.background.paper}`,
  },
}));
